import { useMemo } from "react";
import { removeDiacritics } from "../_common/utils/string";

export default function useNormalize(value = "") {
  return useMemo(() => removeDiacritics(String(value).toLowerCase()), [value]);
}
